export interface CmsOrderConfirmationPage {
  pageTitle: string;
  pageSubtitle: string;
  protectionCardBannerPlanHeader: string;
}
